function getSign(theNumber: number) {
  if (theNumber >= 0) {
    return '+';
  }
  return '-';
}

export default getSign;
